import header_info from './header_info/header_info';

const reducers = {
    header_info
};

export default reducers;